export default "__VITE_ASSET__DHN76zyh__"